var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFrontRut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 66,
    viewBox: "0 0 89 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.1666 1H3.36301C2.05795 1 1 2.05156 1 3.34873V62.6513C1 63.9484 2.05795 65 3.36301 65H86.1666C87.4716 65 88.5296 63.9484 88.5296 62.6513V3.34873C88.5296 2.05156 87.4716 1 86.1666 1Z",
    stroke: "#733FE7",
    strokeWidth: 0.66154,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.8979 10.9189H53.9962",
    stroke: "#733FE7",
    strokeWidth: 2.97693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.9559 10.9189H78.822C79.604 10.9189 80.3541 11.2278 80.9071 11.7774C81.4601 12.3271 81.7708 13.0726 81.7708 13.85V53.9386C81.7708 54.716 81.4601 55.4615 80.9071 56.0112C80.3541 56.5609 79.604 56.8697 78.822 56.8697H11.0182C10.2361 56.8697 9.48605 56.5609 8.93303 56.0112C8.38002 55.4615 8.06934 54.716 8.06934 53.9386V13.8461C8.06934 13.0687 8.38002 12.3232 8.93303 11.7735C9.48605 11.2238 10.2361 10.915 11.0182 10.915L57.9559 10.9189Z",
    stroke: "#733FE7",
    strokeWidth: 2.97693,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1499 10.9189H35.2482",
    stroke: "#733FE7",
    strokeWidth: 2.97693,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6108 34.0078H72.8823",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6108 23.7383H72.8823",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6108 40.6084H72.8823",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M51.6108 46.4766H72.8823",
    stroke: "#733FE7",
    strokeWidth: 1.81923,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2369 36.9562C32.3637 36.9562 34.8986 34.4214 34.8986 31.2945C34.8986 28.1676 32.3637 25.6328 29.2369 25.6328C26.11 25.6328 23.5752 28.1676 23.5752 31.2945C23.5752 34.4214 26.11 36.9562 29.2369 36.9562Z",
    fill: "#733FE7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0878 41.4101C34.6722 40.3533 32.03 39.7871 29.2369 39.7871C26.4438 39.7871 23.8017 40.3533 21.3861 41.4101C19.2724 42.316 17.9136 44.3542 17.9136 46.6566V48.2796H40.5603V46.6566C40.5603 44.3542 39.2015 42.316 37.0878 41.4101Z",
    fill: "#733FE7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.1373,
    y: 20.8038,
    width: 24.9389,
    height: 27.1394,
    rx: 2.20049,
    stroke: "#733FE7",
    strokeWidth: 1.467
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontRut);
export default __webpack_public_path__ + "static/media/front-rut.64da5bda.svg";
export { ForwardRef as ReactComponent };